import data from '@/json/projects'
import * as types from '../mutations-types.js'

const state = {
  show: false,
}

const getters = {
  show: state => state.show,
}

const mutations = {
  [types.SET_SHOW](state, value){
    state.show = !state.show
  },
  setShow(state, value) {
    state.show = value;
  }
}

const actions = {
  toggleShow({commit}, project){
    commit(types.SET_SHOW)
  },
}

export default{
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/nav.js